import React from "react";
import ThesaurusGraph from "../components/ThesaurusGraph.Click.jsx";
// Option A: static import (Vite supports JSON imports)
import data from "../data/thesaurus.json";
// Option B: fetch at runtime (uncomment to use instead of static import)
// import { useEffect, useState } from "react";
// export default function ThesaurusPage() {
//   const [data, setData] = useState({ nodes: [], links: [] });
//   useEffect(() => {
//     fetch("/src/data/thesaurus.json").then(r => r.json()).then(setData).catch(console.error);
//   }, []);
//   return (<div style={{height:"calc(100vh - 64px)", width:"100%", margin:0, padding:0}}>
//     <ThesaurusGraph data={data} />
//   </div>);
// }

export default function ThesaurusPage() {
  return (
    <div style={{height:"calc(100vh - 64px)", width:"100%", margin:0, padding:0}}>
      <ThesaurusGraph data={data} />
    </div>
  );
}
